import React from "react";
import { useOutletContext } from "react-router-dom";
import Body from "@/components/renders/Body";
import { MainLayoutContext } from "@/layouts/mainLayout";

const LandingPage: React.FC = () => {
  // Get data from MainLayout via Outlet context
  const { landingPage, designSystem, plugins, tenantDomain, apiVersion } =
    useOutletContext<MainLayoutContext>();

  // Extract tabs from landingPage
  const tabs = landingPage?.body || [];

  return (
    <Body
      tabs={tabs}
      designSystem={designSystem}
      plugins={plugins}
      tenantDomain={tenantDomain}
      apiVersion={apiVersion}
    />
  );
};

export default LandingPage;
